import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

import { ref, computed } from "vue";
import "./app.css";
import Footer from "@/components/Footer.vue";
import { useRoute } from "vue-router";

import { defineComponent } from "vue";
import TreeBackground from "@/components/StarsBackground.vue";

import TreeVue from "./components/Tree.vue";
import WasmTestVue from "./projectComps/WasmTest.vue";

const __default__ = defineComponent({
  name: "AppVue",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const backgroundClass = computed(() => {
  return route.meta.backgroundColor || "";
});
const currentFont = ref("Helvetica");
const fonts = [
  "Helvetica",
  "MonoFaceRegular",
  "Pixelify_Sans",
  "Libre_Barcode_39",
];
const changeFont = (payload: string) => {
  currentFont.value = payload;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_motion_slide_visible_once_right = _resolveDirective("motion-slide-visible-once-right")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    style: _normalizeStyle({ fontFamily: currentFont.value })
  }, [
    _createVNode(TreeBackground),
    _withDirectives((_openBlock(), _createElementBlock("nav", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("~/Home/")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode("About/")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/projects" }, {
        default: _withCtx(() => [
          _createTextVNode("Projects/")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/resume" }, {
        default: _withCtx(() => [
          _createTextVNode("Resume/")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/contact" }, {
        default: _withCtx(() => [
          _createTextVNode("Contact")
        ]),
        _: 1
      })
    ])), [
      [_directive_motion_slide_visible_once_right]
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("footer", null, [
      _createVNode(Footer, {
        fonts: fonts,
        "current-font": currentFont.value,
        onUpdatedFont: changeFont
      }, null, 8, ["current-font"])
    ])
  ], 4))
}
}

})